import { useColors } from '../../hooks/useColors'

type Props = { formData: Record<string, string>; onChange: (key: string, value: string) => void }

export default function NotificationSettingsTab({ formData, onChange }: Props) {
  const colors = useColors()
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <h3 style={{ margin: 0, color: colors.textPrimary }}>Notification Settings</h3>
      <input value={formData.google_review_url || ''} onChange={(e) => onChange('google_review_url', e.target.value)} placeholder="Google Review URL" />
      <label style={{ color: colors.textPrimary }}>
        <input type="checkbox" checked={String(formData.referral_enabled) === 'true'} onChange={(e) => onChange('referral_enabled', e.target.checked ? 'true' : 'false')} /> Referral Notifications Enabled
      </label>
      <input value={formData.referral_referrer_reward || ''} onChange={(e) => onChange('referral_referrer_reward', e.target.value)} placeholder="Referrer Reward" />
      <input value={formData.referral_referee_reward || ''} onChange={(e) => onChange('referral_referee_reward', e.target.value)} placeholder="Referee Reward" />
    </div>
  )
}
